
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("modal/welcome-invite",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":144}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalwelcome.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":152},"end":{"line":1,"column":183}}})) != null ? stack1 : "")
    + " </div><div class=\"content\"><img src=\"images/welcome_invitation_dialog_illustration.svg\" style=\"display:block;margin:auto;width:110px;height:110px;\"/><p class=\"blockmargin\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalwelcome.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":356},"end":{"line":1,"column":386}}})) != null ? stack1 : "")
    + "</p> "
    + ((stack1 = lookupProperty(helpers,"premiumPermission").call(depth0 != null ? depth0 : (container.nullContext || {}),"inviteOnClickAction",{"name":"premiumPermission","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":391},"end":{"line":1,"column":557}}})) != null ? stack1 : "")
    + " </div></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button data-fw-onclick=\"modalclose|inviteOnClickAction\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalwelcome.button",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":493},"end":{"line":1,"column":525}}})) != null ? stack1 : "")
    + "</button> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;